// SEMENTARA — preview UI/UX schedule baru (admin sahaja), buang bila migrate ke /workspace
import React, { useState, useRef } from 'react';

const MS_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatDateMs = (isoDate) => {
    if (!isoDate) return '—';
    const [year, month, day] = isoDate.split('-');
    return `${parseInt(day, 10)} ${MS_MONTHS[parseInt(month, 10) - 1]} ${year}`;
};

const LEFT_COL = ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00'];
const RIGHT_COL = ['20:00', '22:00', '00:00', '02:00', '04:00', '06:00'];

const PALETTE = ['#A855F7', '#EF4444', '#3B82F6', '#10B981', '#F59E0B', '#EC4899', '#06B6D4', '#8B5CF6'];

export const DEFAULT_TEMPLATES = [
    {
        id: 'akaun-1',
        name: 'Akaun 1',
        color: '#A855F7',
        slots: ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
        customTimes: [],
        startDate: '2026-05-28',
    },
    {
        id: 'akaun-2',
        name: 'Akaun 2',
        color: '#EF4444',
        slots: ['08:00', '12:00', '16:00', '20:00'],
        customTimes: [],
        startDate: '2026-05-28',
    },
    {
        id: 'akaun-3',
        name: 'Akaun 3',
        color: '#3B82F6',
        slots: ['08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '00:00', '02:00'],
        customTimes: ['14:15'],
        startDate: '2026-05-28',
    },
];

const SlotRow = ({ time, ticked, onToggle }) => (
    <button
        onClick={onToggle}
        className="flex items-center gap-3 py-1.5 px-2 -mx-2 rounded-lg hover:bg-slate-50 transition text-left"
    >
        <div
            className={`w-5 h-5 rounded flex items-center justify-center transition shrink-0 ${
                ticked ? 'bg-green-500' : 'bg-white border-2 border-slate-300'
            }`}
        >
            {ticked && (
                <span
                    className="material-symbols-outlined text-white"
                    style={{ fontSize: 16, fontVariationSettings: "'FILL' 1, 'wght' 700" }}
                >
                    check
                </span>
            )}
        </div>
        <span className={`text-base font-semibold tabular-nums ${ticked ? 'text-slate-800' : 'text-slate-400'}`}>
            {time}
        </span>
    </button>
);

const TemplateJadualModal = ({ isOpen, onClose, templates, setTemplates, activeId, setActiveId }) => {
    const [isAddingTime, setIsAddingTime] = useState(false);
    const [newTimeH, setNewTimeH] = useState('');
    const [newTimeM, setNewTimeM] = useState('');

    const [isAddingTemplate, setIsAddingTemplate] = useState(false);
    const [newTplName, setNewTplName] = useState('');
    const [newTplColor, setNewTplColor] = useState(PALETTE[0]);

    const dateInputRef = useRef(null);

    if (!isOpen) return null;

    const active = templates.find(t => t.id === activeId);
    const totalSlots = active ? active.slots.length + (active.customTimes?.length || 0) : 0;

    const toggleSlot = (slot) => {
        setTemplates(prev => prev.map(t =>
            t.id === activeId
                ? {
                    ...t,
                    slots: t.slots.includes(slot)
                        ? t.slots.filter(s => s !== slot)
                        : [...t.slots, slot].sort(),
                }
                : t
        ));
    };

    const addCustomTime = () => {
        const hh = (newTimeH || '').padStart(2, '0');
        const mm = (newTimeM || '').padStart(2, '0');
        const hN = parseInt(hh, 10);
        const mN = parseInt(mm, 10);
        if (isNaN(hN) || isNaN(mN) || hN < 0 || hN > 23 || mN < 0 || mN > 59) return;
        const newTime = `${hh}:${mm}`;
        setTemplates(prev => prev.map(t =>
            t.id === activeId
                ? { ...t, customTimes: [...(t.customTimes || []), newTime] }
                : t
        ));
        setNewTimeH('');
        setNewTimeM('');
        setIsAddingTime(false);
    };

    const removeCustomTime = (time) => {
        setTemplates(prev => prev.map(t =>
            t.id === activeId
                ? { ...t, customTimes: (t.customTimes || []).filter(c => c !== time) }
                : t
        ));
    };

    const addTemplate = () => {
        if (!newTplName.trim()) return;
        const id = `tpl-${Date.now()}`;
        const newTpl = {
            id,
            name: newTplName.trim(),
            color: newTplColor,
            slots: ['08:00', '12:00', '16:00', '20:00'],
            customTimes: [],
            startDate: new Date().toISOString().slice(0, 10),
        };
        setTemplates(prev => [...prev, newTpl]);
        setActiveId(id);
        setNewTplName('');
        setNewTplColor(PALETTE[0]);
        setIsAddingTemplate(false);
    };

    const removeTemplate = (id) => {
        const remaining = templates.filter(t => t.id !== id);
        setTemplates(remaining);
        if (id === activeId) {
            setActiveId(remaining[0]?.id || null);
        }
    };

    const setStartDate = (date) => {
        setTemplates(prev => prev.map(t =>
            t.id === activeId
                ? { ...t, startDate: date }
                : t
        ));
    };

    // ═══ Empty state ═══
    if (templates.length === 0 || !active) {
        return (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
                onClick={onClose}
            >
                <div
                    className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center relative"
                    onClick={e => e.stopPropagation()}
                >
                    <button
                        onClick={onClose}
                        className="absolute top-3 right-3 p-1 text-slate-400 hover:text-slate-600 transition"
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                    <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-rose-50 flex items-center justify-center">
                        <span
                            className="material-symbols-outlined text-rose-500"
                            style={{ fontSize: 32, fontVariationSettings: "'FILL' 1" }}
                        >
                            event_available
                        </span>
                    </div>
                    <h3 className="text-lg font-semibold text-slate-800 mb-1.5">No schedule template yet</h3>
                    <p className="text-sm text-slate-500 mb-5 leading-relaxed">
                        Create your first template to automatically schedule TikTok uploads
                        at your chosen times each day.
                    </p>
                    <button
                        onClick={() => {
                            setTemplates(DEFAULT_TEMPLATES);
                            setActiveId('akaun-1');
                        }}
                        className="w-full bg-rose-500 hover:bg-rose-600 text-white font-semibold py-3 rounded-xl transition"
                    >
                        Create First Template
                    </button>
                </div>
            </div>
        );
    }

    // ═══ Main modal ═══
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto relative"
                onClick={e => e.stopPropagation()}
            >
                {/* ── Header ── */}
                <div className="flex items-center justify-between px-5 pt-5 pb-3 relative">
                    <div className="w-7" />
                    <h2 className="text-lg font-semibold text-slate-800">Schedule Template</h2>
                    <button
                        onClick={onClose}
                        className="p-1 text-slate-400 hover:text-slate-600 transition"
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                {/* ── Add template inline form ── */}
                {isAddingTemplate && (
                    <div className="mx-5 mb-3 p-3 bg-slate-50 rounded-xl border border-slate-200">
                        <input
                            autoFocus
                            value={newTplName}
                            onChange={e => setNewTplName(e.target.value)}
                            placeholder="Account name (e.g. Skincare Account)"
                            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-rose-200 mb-3"
                            onKeyDown={e => {
                                if (e.key === 'Enter') addTemplate();
                                if (e.key === 'Escape') { setIsAddingTemplate(false); setNewTplName(''); }
                            }}
                        />
                        <div className="flex gap-2 mb-3 flex-wrap">
                            {PALETTE.map(color => (
                                <button
                                    key={color}
                                    onClick={() => setNewTplColor(color)}
                                    className="w-7 h-7 rounded-full transition flex items-center justify-center ring-offset-2 ring-2 ring-transparent"
                                    style={{
                                        background: color,
                                        ...(newTplColor === color ? { boxShadow: `0 0 0 2px white, 0 0 0 4px ${color}` } : {}),
                                    }}
                                >
                                    {newTplColor === color && (
                                        <span className="material-symbols-outlined text-white" style={{ fontSize: 16 }}>check</span>
                                    )}
                                </button>
                            ))}
                        </div>
                        <div className="flex gap-2">
                            <button
                                onClick={addTemplate}
                                className="flex-1 bg-rose-500 hover:bg-rose-600 text-white text-sm font-semibold py-2 rounded-lg transition"
                            >
                                Save
                            </button>
                            <button
                                onClick={() => { setIsAddingTemplate(false); setNewTplName(''); }}
                                className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-600 text-sm font-semibold py-2 rounded-lg transition"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {/* ── Account tabs ── */}
                <div className="px-5 pb-3 flex gap-2 flex-wrap items-center">
                    {templates.map(t => {
                        const isActive = t.id === activeId;
                        return (
                            <div key={t.id} className="relative group">
                                <button
                                    onClick={() => setActiveId(t.id)}
                                    className={`px-3 py-1.5 rounded-full text-xs font-semibold flex items-center gap-1.5 transition border ${
                                        isActive
                                            ? 'border-transparent text-white shadow-sm'
                                            : 'border-slate-200 text-slate-600 hover:border-slate-300 bg-white'
                                    }`}
                                    style={{ background: isActive ? t.color : 'white' }}
                                >
                                    <span
                                        className="w-2 h-2 rounded-full"
                                        style={{ background: isActive ? 'rgba(255,255,255,0.95)' : t.color }}
                                    />
                                    {t.name}
                                </button>
                                {templates.length > 1 && (
                                    <button
                                        onClick={() => removeTemplate(t.id)}
                                        className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-slate-400 hover:bg-rose-500 text-white opacity-0 group-hover:opacity-100 transition flex items-center justify-center shadow"
                                        title="Delete template"
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: 10 }}>close</span>
                                    </button>
                                )}
                            </div>
                        );
                    })}
                    {!isAddingTemplate && (
                        <button
                            onClick={() => setIsAddingTemplate(true)}
                            className="px-3 py-1.5 rounded-full text-xs font-semibold flex items-center gap-1 border border-dashed border-slate-300 text-slate-500 hover:border-rose-300 hover:text-rose-500 hover:bg-rose-50 transition"
                        >
                            <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add</span>
                            Add Template
                        </button>
                    )}
                </div>

                <div className="border-t border-slate-100 mx-5" />

                {/* ── Tambah Masa Baru ── */}
                <div className="px-5 pt-4">
                    {!isAddingTime ? (
                        <button
                            onClick={() => setIsAddingTime(true)}
                            className="px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1 bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                        >
                            <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add</span>
                            Add New Time
                        </button>
                    ) : (
                        <div className="flex items-center gap-2 p-2 bg-blue-50 rounded-lg w-fit">
                            <input
                                type="number"
                                value={newTimeH}
                                onChange={e => setNewTimeH(e.target.value)}
                                placeholder="HH"
                                min="0"
                                max="23"
                                className="w-14 px-2 py-1.5 border border-slate-200 rounded text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                                autoFocus
                            />
                            <span className="text-slate-500 font-semibold">:</span>
                            <input
                                type="number"
                                value={newTimeM}
                                onChange={e => setNewTimeM(e.target.value)}
                                placeholder="MM"
                                min="0"
                                max="59"
                                className="w-14 px-2 py-1.5 border border-slate-200 rounded text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                                onKeyDown={e => {
                                    if (e.key === 'Enter') addCustomTime();
                                    if (e.key === 'Escape') {
                                        setIsAddingTime(false);
                                        setNewTimeH('');
                                        setNewTimeM('');
                                    }
                                }}
                            />
                            <button
                                onClick={addCustomTime}
                                className="p-1.5 text-green-600 hover:bg-green-100 rounded transition"
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>check</span>
                            </button>
                            <button
                                onClick={() => { setIsAddingTime(false); setNewTimeH(''); setNewTimeM(''); }}
                                className="p-1.5 text-slate-400 hover:bg-slate-100 rounded transition"
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 18 }}>close</span>
                            </button>
                        </div>
                    )}
                </div>

                {/* ── Time slot grid (2 col × 6 row) ── */}
                <div className="px-5 py-4 grid grid-cols-2 gap-x-12 gap-y-1">
                    {LEFT_COL.map((slot, i) => {
                        const right = RIGHT_COL[i];
                        return (
                            <React.Fragment key={i}>
                                <SlotRow time={slot} ticked={active.slots.includes(slot)} onToggle={() => toggleSlot(slot)} />
                                <SlotRow time={right} ticked={active.slots.includes(right)} onToggle={() => toggleSlot(right)} />
                            </React.Fragment>
                        );
                    })}
                </div>

                {/* ── Custom times row ── */}
                {active.customTimes && active.customTimes.length > 0 && (
                    <div className="px-5 pb-3">
                        <div className="text-[10px] font-bold text-slate-400 mb-2 uppercase tracking-wider">
                            Custom Times
                        </div>
                        <div className="flex gap-2 flex-wrap">
                            {active.customTimes.map(time => (
                                <div
                                    key={time}
                                    className="px-3 py-1.5 bg-rose-50 text-rose-700 text-xs font-semibold rounded-full flex items-center gap-1.5"
                                >
                                    <span className="w-2 h-2 rounded-full bg-rose-400" />
                                    {time}
                                    <button
                                        onClick={() => removeCustomTime(time)}
                                        className="text-rose-400 hover:text-rose-700 transition"
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: 14 }}>close</span>
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* ── Summary ── */}
                <div className="text-center pb-2 pt-1 text-sm text-slate-700">
                    Selected Schedule : <span className="font-bold">{totalSlots} Videos/Day</span>
                </div>

                {/* ── Start date picker ── */}
                <div className="px-5 pb-4 text-center">
                    <div className="text-xs text-slate-500 mb-2 font-semibold">Start Schedule On</div>
                    <button
                        onClick={() => dateInputRef.current?.showPicker?.()}
                        className="px-5 py-2 bg-rose-500 hover:bg-rose-600 text-white text-sm font-bold rounded-full transition shadow-sm tabular-nums"
                    >
                        {formatDateMs(active.startDate)}
                    </button>
                    <input
                        ref={dateInputRef}
                        type="date"
                        value={active.startDate}
                        onChange={e => setStartDate(e.target.value)}
                        className="absolute opacity-0 pointer-events-none w-0 h-0"
                        aria-hidden="true"
                    />
                </div>

                {/* ── Save button ── */}
                <div className="px-5 pb-5">
                    <button
                        disabled={totalSlots === 0}
                        className={`w-full font-bold py-3.5 rounded-xl text-sm tracking-wider transition ${
                            totalSlots === 0
                                ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                                : 'bg-rose-500 hover:bg-rose-600 text-white shadow-md'
                        }`}
                    >
                        SAVE SCHEDULE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TemplateJadualModal;
